import type { ObItemWithSubmission } from "./onboarding-api";

/**
 * Split a `photo_upload_section`'s visible items into the questions that render
 * as form fields and the documents that render as upload tiles.
 *
 * This exists because the screen used to render only the upload tiles, so any
 * item that was not a `document_upload` was silently dropped. That is not a
 * cosmetic gap: an item that never renders can never be answered, and a
 * mandatory one then blocks activation forever while being invisible.
 *
 * It happened in production. "Which TB test do you have?" — a radio added to
 * route the TB pathway — was seeded mandatory to 3,789 applicants in this
 * subsection, and 2,565 of them ended up with it as their ONLY outstanding
 * requirement: blocked by a question no device would draw. The uploads branched
 * off it too, so a rule whose parent is unanswerable never fired and the second
 * step and chest X-ray became unreachable as well.
 *
 * `not_required` is excluded from both lists: that is the status a follow-up
 * carries before it is triggered, and a retired item carries for good.
 */
export function partitionPhotoSectionItems(visibleItems: ObItemWithSubmission[]): {
    questions: ObItemWithSubmission[];
    uploads: ObItemWithSubmission[];
} {
    const live = visibleItems.filter((item) => item.submission?.status !== "not_required");
    return {
        questions: live.filter((item) => item.itemType !== "document_upload"),
        uploads: live.filter((item) => item.itemType === "document_upload")
    };
}
